export enum TipoReferenciaEnum {
   "Anula Documento de Referencia" = 1,
   "Corrige Texto Documento Referencia" = 2,
   "Corrige Montos" = 3,
}
